import type { EntryPointComponent } from 'react-relay';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';

import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { featuresResource } from '@jira/router-resources__service-project-features/src/featuresResource.tsx';
import { summaryPageConfigResource } from '@jira/router-resources__service-desk-project-summary/src/useSummaryPageConfig.tsx';
import {
	queuesNavigationItems,
	queueSidebarQueuesCategoryStateResource,
} from '@jira/router-resources__service-desk-queues/src/queuesNavigationItems.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { projectSettingsServicedeskItsmFeaturesRoute } from '@jira/router-routes__project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskItsmFeaturesRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { fg } from '@atlassian/jira-feature-gating';
import type { Route } from '@atlassian/react-resource-router';
import ServiceDeskItsmFeatures, {
	LazyProjectSettingsServiceDeskItsmFeatures,
} from './ui/service-desk-itsm-features/index.tsx';

const projectSettingsServicedeskItsmFeaturesPageEntryPoint = createPageEntryPoint({
	main: {
		root: JSResourceForUserVisible<EntryPointComponent<{}, {}, {}, {}>>(
			/* webpackChunkName: "async-project-settings-service-desk-itsm-features", jiraSpaEntry: "async-project-settings-service-desk-itsm-features" */ '@jira/spa-apps__project-settings-service-desk-itsm-features/src/ProjectSettingsServiceDeskItsmFeatures.tsx',
			{ entryFsSsrLiftImportToModule: false },
		),
		getPreloadProps: () => ({}),
	},
});

export const projectSettingsServicedeskItsmFeaturesRouteEntry: Route = createEntry(
	projectSettingsServicedeskItsmFeaturesRoute,
	() => ({
		group: 'project-settings-servicedesk',
		ufoName: 'jsm-features-settings',

		// eslint-disable-next-line no-restricted-syntax
		component: fg('nike_entrypoint_migration_batch_2') ? undefined : ServiceDeskItsmFeatures,

		entryPoint: () =>
			fg('nike_entrypoint_migration_batch_2')
				? projectSettingsServicedeskItsmFeaturesPageEntryPoint
				: undefined,
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		resources: [
			...getServiceDeskSettingsResources(),
			featuresResource,
			getConsolidationStateResource(),
			resourceWithCondition(() => fg('jsm_project_summary_default_on'), summaryPageConfigResource),
			resourceWithCondition(() => fg('jsm-case-management-queues-sidebar'), queuesNavigationItems),
			resourceWithCondition(
				() => fg('jsm-case-management-queues-sidebar'),
				queueSidebarQueuesCategoryStateResource,
			),
		],

		forPaint: [LazyAtlassianNavigation, LazyProjectSettingsServiceDeskItsmFeatures],
		perfMetricKey: 'jsm-features-settings',

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
